import classNames from 'classnames'

import style from './style.scss'

type Props = React.HTMLProps<HTMLSelectElement>

function Select({ className, ...props }: Props) {
  return <select className={classNames(style.select, className)} {...props} />
}

export default Select
